export const sideProjects = [
  {
    title: "Margarita Dad",
    description: "A full country album written and produced with AI. Songs about life, fatherhood, bad decisions, and good drinks. Out now on Spotify, Apple Music, and everywhere else.",
    status: "Streaming",
    link: "https://open.spotify.com/artist/1tSHTliFCTa24gb6l3dqO2?si=K_wv8D29QF-qTFySO6S7ww&utm_source=copy-link",
    linkLabel: "Listen on Spotify"
  },
  {
    title: "Molar Messenger",
    description: "An AI-driven SMS customer service platform built specifically for dental offices. Handles appointment reminders, patient questions, and follow-ups without tying up front desk staff.",
    status: "In Development",
    link: null,
    linkLabel: null
  },
  {
    title: "Bonky Rat and Goose",
    description: "A creative project featuring my dog, Butters (Goose), exploring digital storytelling and character design.",
    status: "Ongoing",
    link: null,
    linkLabel: null
  },
  {
    title: "Video-Generation Experiments",
    description: "Testing the limits of generative AI for producing short-form video content and procedural animation.",
    status: "Active",
    link: null,
    linkLabel: null
  },
  {
    title: "Small Games",
    description: "Prototyping mechanics and learning new frameworks through building simple, focused web games.",
    status: "Occasional",
    link: null,
    linkLabel: null
  },
  {
    title: "Automation Tools",
    description: "Building personal scripts and workflows to eliminate repetitive digital tasks from my daily life.",
    status: "Active",
    link: null,
    linkLabel: null
  },
  {
    title: "Website Prototypes",
    description: "Quick build-outs of product ideas and landing pages just to see if a concept has legs.",
    status: "Ongoing",
    link: null,
    linkLabel: null
  },
  {
    title: "Home and Automotive",
    description: "Applying the 'figure it out' mentality to physical projects, repairs, and optimizations off-screen.",
    status: "Always",
    link: null,
    linkLabel: null
  }
];
